/* ============================================================================
   LUMY — "Ofertas temporales" (bloque de la PDP)

   Tres cosas:
     1. El contador. Guarda la FECHA DE VENCIMIENTO en localStorage, no los
        minutos que faltan, así el tiempo corre de verdad entre visitas. Cuando
        llega a cero sortea uno nuevo y sigue.
     2. Qué tarjetas se muestran. El HTML trae más candidatos de los que se ven,
        todos ocultos. Acá se lee el carrito y se muestran los primeros que NO
        estén ya agregados.
   El botón de cada tarjeta es el NATIVO del theme (viene del snippet
   `horizontal-product`), así que al agregar salta `cart:change` solo y la
   tarjeta desaparece sin que acá haya que hacer nada.
   ========================================================================== */
(function () {
  'use strict';

  /* El snippet carga este archivo cada vez que se dibuja (PDP y cart): que corra
     una sola vez. */
  if (window.__lumyTempOffers) return;
  window.__lumyTempOffers = true;

  var CLAVE = 'lumy-ofertas-temporales-vence';

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------------------------------------------------------------- contador */

  function leerVencimiento() {
    try {
      var v = parseInt(window.localStorage.getItem(CLAVE), 10);
      return isNaN(v) ? 0 : v;
    } catch (e) {
      return 0;
    }
  }

  function guardarVencimiento(v) {
    try {
      window.localStorage.setItem(CLAVE, String(v));
    } catch (e) {
      /* modo incógnito o storage bloqueado: el contador sigue andando, solo
         que arranca de nuevo en cada carga. */
    }
  }

  function nuevoVencimiento(minSegs, maxSegs) {
    var total = minSegs + Math.floor(Math.random() * (maxSegs - minSegs + 1));
    var v = Date.now() + total * 1000;
    guardarVencimiento(v);
    return v;
  }

  function dosDigitos(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function arrancarContador(panel) {
    var salida = panel.querySelector('.lumy-tof__timer');
    if (!salida) return;

    var minSegs = parseInt(panel.dataset.min, 10) || 780;
    var maxSegs = parseInt(panel.dataset.max, 10) || 2099;

    var vence = leerVencimiento();
    if (!vence || vence <= Date.now()) vence = nuevoVencimiento(minSegs, maxSegs);

    function pintar() {
      var faltan = Math.round((vence - Date.now()) / 1000);
      if (faltan <= 0) {
        vence = nuevoVencimiento(minSegs, maxSegs);
        faltan = Math.round((vence - Date.now()) / 1000);
      }
      var m = Math.floor(faltan / 60);
      var s = faltan % 60;
      salida.textContent = dosDigitos(m) + ':' + dosDigitos(s);
    }

    pintar();
    /* El cart drawer se redibuja entero en cada cambio: el panel viejo queda
       fuera del documento y su reloj se apaga solo. */
    var reloj = setInterval(function () {
      if (!panel.isConnected) { clearInterval(reloj); return; }
      pintar();
    }, 1000);
  }

  /* ------------------------------------------------- qué tarjetas se muestran */

  function idsEnCarrito(carrito) {
    /* Se guardan los dos: la variante para saber que tarjeta sacar, y el producto
       para poder saltear el de la ficha que se esta viendo. */
    var ids = { productos: {}, variantes: {} };
    ((carrito && carrito.items) || []).forEach(function (item) {
      ids.productos[String(item.product_id)] = true;
      ids.variantes[String(item.variant_id)] = true;
    });
    return ids;
  }

  /* El producto de la PDP que se está viendo. Shopify lo publica en todas las
     fichas; en el resto de las páginas no existe. */
  function productoDeLaPagina() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return m && m.product && m.product.id ? String(m.product.id) : null;
  }

  function repartir(panel, carrito) {
    var cuantas = parseInt(panel.dataset.show, 10) || 3;
    var enCarrito = idsEnCarrito(carrito);
    var actual = productoDeLaPagina();
    var visibles = 0;

    panel.querySelectorAll('.lumy-tof__card').forEach(function (card) {
      var ocupada = enCarrito.variantes[card.dataset.variantId] ||
                    (actual && card.dataset.productId === actual);
      var mostrar = !ocupada && visibles < cuantas;
      card.hidden = !mostrar;
      if (mostrar) visibles++;
    });

    /* Si no quedó ninguna para ofrecer, no tiene sentido dejar el título y el
       contador solos. */
    panel.hidden = visibles === 0;
  }

  function refrescar(panel) {
    return fetch(raiz() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) { repartir(panel, carrito); })
      .catch(function () { repartir(panel, { items: [] }); });
  }

  /* ------------------------------------------------------------------ arranque */

  function iniciar(panel) {
    if (panel.dataset.lumyListo) return;
    panel.dataset.lumyListo = '1';

    arrancarContador(panel);
    refrescar(panel);
  }

  function barrer() {
    document.querySelectorAll('.lumy-tof').forEach(iniciar);
  }

  /* Un solo listener para todos los paneles (antes era uno por panel, y con los
     redibujos del cart se iban acumulando). */
  document.addEventListener('cart:change', function (e) {
    if (!e.detail || !e.detail.cart) return;
    document.querySelectorAll('.lumy-tof').forEach(function (panel) { repartir(panel, e.detail.cart); });
  });
  document.addEventListener('cart:refresh', function () {
    document.querySelectorAll('.lumy-tof').forEach(refrescar);
  });

  /* El cart drawer mete HTML nuevo cada vez que cambia el carrito: cualquier
     panel que aparezca se inicia solo. */
  new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      var nodos = cambios[i].addedNodes;
      for (var j = 0; j < nodos.length; j++) {
        var n = nodos[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('.lumy-tof')) iniciar(n);
        if (n.querySelectorAll) n.querySelectorAll('.lumy-tof').forEach(iniciar);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', barrer);
  } else {
    barrer();
  }
  /* El editor de temas vuelve a pintar la sección al tocar un setting. */
  document.addEventListener('shopify:section:load', barrer);
})();
